<p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
<div class="content-block">
  <article class="article " style="margin-top:1rem">
    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>Input Inspection</h2>
      </div>
      <div style="flex:1"></div>
    </div>
    <div class="form-container">
      <div class="form-column" style="border:none">
        <div class="form-column" style="margin-left:0px;margin-right:0px">
          <div class="form-container">
            <div class="form-column" style="border:none">

              <p>You can input inspection details on this page.</p>

              <div class="form-group" style="width: 100%;margin-top: 0px;">
                <label>Exam Date</label>
                <p-calendar name="exam_Date" style="width: 50%;" firstDayOfWeek="1"
                  [style]="{'width':'100%', 'border-color':'#ccc', 'height': 'calc(1.5em + .75rem + 2px)'}"
                  [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'0px 10px','height': 'calc(1rem * var(--pico-line-height) + var(--pico-form-element-spacing-vertical) * 2 + var(--pico-border-width) * 2);'}"
                  [(ngModel)]="exam_Date" dateFormat="dd/mm/yy"></p-calendar>

                <div class="form-group" style="width: 100%;margin-left: 0rem;margin-top: 1rem;">
                  <label>Engineer *</label>
                  <app-technician-picker [technicianId]="technicianId" style="width: 50%;"
                    [_placeholder]="'Please Select'"
                    (onTechnicianSet)="onTechnicianChange($event)"></app-technician-picker>

                </div>
                <!-- 
                <div class="form-group" style="width: 100%;margin-left: 0rem;margin-top: 1rem;">
                  <label>Authenticator *</label>
                  <app-technician-picker [technicianId]="authenticatorId" [_placeholder]="'Please Select'"
                    (onTechnicianSet)="onAuthenticatorChange($event)"></app-technician-picker>

                </div> -->

              </div>


            </div>
            <div class="form-column" style="border:none">

              <h5>Search Equipment</h5>
              <div class="form-groups-row ">

                <div class="form-group" style="width: 100%;">
                  <label>Serial Number / Description</label>
                  <div style="display: flex;flex-direction: row;    align-items: center;">
                    <input type="text" [(ngModel)]="searchQuery" />
                    <button class="btn btn-primary" (click)="search()">Search</button>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>



        <div class="form-column topMargin" style="margin-left:0px;margin-right:0px">
          <div class="title-container" (click)="setShowNewOption()">
            <i class="fa fa-chevron-left primary" style=" cursor: pointer;font-size: 2em;margin-left: 2rem"
              *ngIf="showNewOption"></i>
            <i class="fa fa-chevron-down primary" style=" cursor: pointer;font-size: 2em;margin-left: 2rem;"
              *ngIf="!showNewOption"></i>
            <h3 style="flex:10;margin-right: 2rem">Add New Equipment Item and Inspection</h3>

          </div>

          <div class="form-column borderless" *ngIf="showNewOption">


            <div class="form-groups-row buffer-bottom">
              <div class="form-group" style="width: 100%;">
                <label>Serial # *</label>
                <input type="text" [(ngModel)]="equip.serial_Num" />
              </div>
              <div class="form-group" style="width: 100%;">
                <label>Description *</label>
                <input type="text" [(ngModel)]="equip.description" />
              </div>
            </div>


            <div class="form-groups-row buffer-bottom">
              <div class="form-group" style="width: 100%;">
                <label>SWL *</label>
                <input type="text" [(ngModel)]="equip.swl" />
              </div>
              <div class="form-group" style="width: 100%;">
                <label>Category *</label>
                <app-category-picker [categoryId]="equip.category_Id" [_placeholder]="'Please Select'"
                  (onCategorySet)="onCategoryChange($event)"></app-category-picker>

              </div>
            </div>


            <div class="form-groups-row buffer-bottom">
              <div class="form-group" style="width: 100%;">
                <label>Location *</label>
                <app-location-picker [locationId]="equip.location_Id" [companyId]="company_Id"
                  (onLocationSet)="onLocationChange($event)"></app-location-picker>
              </div>
              <div class="form-group" style="width: 100%;">
                <div style="display: flex;flex-direction: row;    align-items: center;">
                  <div style="width:100%;">
                    <app-sublocation-picker [triggerUpdate]="triggerSubLocationUpdate"
                      [sublocationId]="equip.sublocationId" [locationId]="equip.location_Id"
                      (onSublocationSet)="onSublocationChange($event)"
                      [_placeholder]="Optional"></app-sublocation-picker>
                  </div>
                  <button class="btn btn-primary" (click)="addSublocation()">+</button>
                </div>
                </div>
                </div>
                
                
                <div class="btn-container">
                  <div style="display: flex;flex-direction: row;    align-items: center;">
                
                    <div class="form-group" style="width: 100%;">
                      <label>Job Number</label>
                      <input type="text" [(ngModel)]="equip.doc" />
                    </div>
                    <button class="btn btn-primary" (click)="saveEquipment()">Submit</button>
                  </div>
                </div>
                </div>


        </div>
        <div class="form-column borderless topMargin" style="margin-left:0px;margin-right:0px" *ngIf="showEquipment">
          <div class="btn-container">
            <h3 *ngIf="selectedRows.length == 0">Select Item to inspect</h3>
            <h3 *ngIf="selectedRows.length > 0 ">Selected {{selectedRows.length}} Items to inspect</h3>

            <button class="btn btn-primary" *ngIf="selectedRows.length > 0 " (click)="inspect()">Inspect</button>

          </div>

          <app-loading-icon *ngIf="loading"></app-loading-icon>
          <div class="form-column borderless" style="display: block;padding:0px;margin:0px" *ngIf="!loading">
            <ngx-datatable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
              [headerHeight]="50" [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material"
              [rows]="rows" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true"
              [rowHeight]="'auto'">

              <ngx-datatable-column name="Location" prop="location_Name">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div>{{ value }}</div>
                </ng-template>
              </ngx-datatable-column>


              <ngx-datatable-column name="Category" prop="category_Name">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div>{{ value }}</div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Description" prop="description">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div>{{ value }}</div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Serial #" prop="serial_Num">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div>{{ value }}</div>
                </ng-template>
              </ngx-datatable-column>


              <ngx-datatable-column name="Basket" [width]="100" prop="id" [resizeable]="false" [sortable]="false"
                [draggable]="false" [canAutoResize]="false">

                <ng-template ngx-datatable-header-template let-value="value" let-selectFn="selectFn">

                  <div style="cursor: pointer;margin-left: 0.5rem;" (click)="addAlltoBasket()">
                    <i *ngIf="!allRowsSelected" style="text-align:start;cursor: pointer;" class="fa fa-plus"></i>
                  </div>

                  <div style="cursor: pointer;margin-left: 0.5rem;" (click)="addAlltoBasket()">
                    <i *ngIf="allRowsSelected" style="text-align:start;cursor: pointer;" class="fa fa-minus"></i>
                  </div>
                </ng-template>

                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div class="success" style="cursor: pointer;" (click)="addToBasket(row,1)">
                    <i *ngIf="(row.selected == undefined || row.selected == false) "
                      style="text-align:start;cursor: pointer;" class="fa fa-plus"></i>
                  </div>
                  <div class="danger" style="text-align:start;cursor: pointer;" (click)="removeFromBasket(row,1)"
                    *ngIf="(row.selected == true)">
                    <i class="fa fa-minus"></i>
                  </div>
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>
          </div>




        </div>

      </div>

    </div>
  </article>

</div>



<popup-modal id="popup-sublocation-add">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Add new Sublocation</h2>
      </div>

      <div class="popup-content">
        <div class="input-column">
          <table>
            <tr>
              <td><label>Name</label></td>
              <td> <input type="text" [(ngModel)]="subLocationName" /></td>
            </tr>
          </table>
        </div>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-sublocation-add')">Cancel</button>
            <button class="btn btn-primary" (click)="saveSubLocation()">Save</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>

<popup-modal id="popup-inspection" #popupinspection>
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h3 *ngIf="selectedRows.length == 1">Inspecting {{selectedRows[0].serial_Num}}</h3>
        <h3 *ngIf="selectedRows.length > 1 ">Inspecting {{selectedRows.length}} Items</h3>

      </div>

      <div class="popup-content">

        <div class="input-column">
          <div class="input-row">
            <label>Is this the first examination after installation or assembly at a new site or location?</label>
            <input type="checkbox" id="switch-first_Examination" name="switch-first_Examination" role="switch"
              [(ngModel)]="inspection.first_Examination" />
          </div>
          <div class="input-row" *ngIf="inspection.first_Examination">
            <label>If the answer to the above question is YES has the equipment been installed correctly?</label>
            <input type="checkbox" id="switch-installed_Correctly" name="switch-installed_Correctly" role="switch"
              [(ngModel)]="inspection.installed_Correctly" />
          </div>
          <div class="input-row">
            <label>Purpose of Examination</label>
            <app-purpose-picker style="width: 50%;" [purposeId]="inspection.purpose_Of_Examination_Id"
              (onPurposeSet)="onPurposeChange($event)"></app-purpose-picker>
          </div>

          <div class="input-row column">
            <label>Identification of any part found to have a defect which is or could become a danger to persons and a
              description of
              the defect: (If none state NONE)</label>
            <textarea wrap="soft" type="text"
              style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3"
              name="messageBody" [innerHTML]="inspection.danger_To_Persons" placeholder="NONE"
              [(ngModel)]="inspection.danger_To_Persons"></textarea>
          </div>

          <div  class="input-row column" style="width: 100%;"
            *ngIf="inspection.danger_To_Persons != null && inspection.danger_To_Persons != undefined && inspection.danger_To_Persons != '' && inspection.danger_To_Persons.toUpperCase() != 'NONE' ">
            <table class="borderless">
              <tr style="margin-bottom: 0.5rem;">
                <td >
                  <label>Is the above an existing or imminent danger to persons
                    <br />
                    <strong>*Note-This is a reportable defect</strong></label>
                </td>
                <td>
                  <input type="checkbox" id="switch-immediate_To_Persons" name="switch-immediate_To_Persons"
                    role="switch" (change)="immediateToPersonsChanged()"
                    [(ngModel)]="inspection.immediate_To_Persons" />
                </td>

              </tr>
              <tr *ngIf="!inspection.immediate_To_Persons">
                <td>
                  <label style="margin-top: 1rem;">Is the above a defect which is not yet but could become a danger to persons:<br/> (If YES state the
                    date by when)</label>
                </td>
                <td>
                  <input type="checkbox" id="switch-become_Danger_To_Persons" name="switch-become_Danger_To_Persons"
                    role="switch" [(ngModel)]="inspection.become_Danger_To_Persons" />

                
                </td>

              </tr>
              <tr *ngIf="inspection.become_Danger_To_Persons && !inspection.immediate_To_Persons">
                <td>
                   <input type="text" style="width:100%" [(ngModel)]="inspection.repair_Date" placeholder="Please state by when" />
                </td>
                <td>
                   <i
                    class="fa fa-calendar primary" style="font-size: 2em;margin-right: 0.25rem;display: flex;flex-direction: row;    align-items: center;justify-content: center;align-items: center;" aria-hidden="true"
                    (click)="openCalendar($event)"></i>
                <p-calendar name="repair_Date_Calendar" firstDayOfWeek="1"
                    #repair_Date_Calendar [style]="{'width':'100%', 'border-color':'#ccc', 'margin-left': '0.5rem'}" [hidden]="true"
                    appendTo="body" (onSelect)="onCalendarChange()" [inputStyle]="{'width':'100%', 'border-color':'#ccc'}"
                    [(ngModel)]="inspection.repair_Date_Date" panelStyleClass="modal-calendar" dateFormat="dd/mm/yy"></p-calendar>
                </td>

              </tr>
              </table>
            
          </div>

          
            <div class="input-row column">
              <label>Particulars of any repair, renewal or alteration required to remedy the defect identified
                above</label>
              <textarea wrap="soft" type="text"
                style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3" name="repair"
                [innerHTML]="inspection.repair" placeholder="NONE" [(ngModel)]="inspection.repair"></textarea>
            </div>

          <div class="input-row column">
            <label>Observations / Additional comments relative to this thorough examination</label>
            <textarea wrap="soft" type="text"
              style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3"
              name="observations" [innerHTML]="inspection.observations" placeholder="NONE"
              [(ngModel)]="inspection.observations"></textarea>
          </div>

          <div class="input-row column">
            <label>IS THIS EQUIPMENT SAFE TO OPERATE?</label>
            <input type="checkbox" id="switch-safe_For_Use" name="switch-safe_For_Use" role="switch"
              (change)="updateNextInspectionDate()" [(ngModel)]="inspection.safe_For_Use" />
          </div>

          <div class="input-row column">
            <label>Next Inspection Date</label>

            <p-calendar name="next_Inspection_Date" style="width: 50%;" firstDayOfWeek="1"
              [style]="{'width':'100%', 'border-color':'#ccc'}" appendTo="body"
              [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'0px 10px'}"
              [(ngModel)]="inspection.next_Inspection_Date" dateFormat="dd/mm/yy"></p-calendar>

          </div>

        </div>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-inspection')">Cancel</button>
            <button class="btn btn-primary" (click)="saveInspection()">Save</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>